/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsThreadChartProduct
 */
export interface ControlcenterMelcoModelsThreadChartProduct {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsThreadChartProduct
     */
    product_code?: string | null;
}

export function ControlcenterMelcoModelsThreadChartProductFromJSON(json: any): ControlcenterMelcoModelsThreadChartProduct {
    return ControlcenterMelcoModelsThreadChartProductFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsThreadChartProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsThreadChartProduct {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
    };
}

export function ControlcenterMelcoModelsThreadChartProductToJSON(value?: ControlcenterMelcoModelsThreadChartProduct | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product_code': value.product_code,
    };
}


